module.exports = __webpack_public_path__ + "static/media/tiger.f4fde2f0.png";